import React, { FC, useEffect, useRef, useState } from 'react'
import { Column } from 'react-table'
import Table from '../../components/Table'
import { Button, Container, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers'
import * as StatsAPI from '../../api/statistics/statistics'
import * as StatsModels from '../../api/statistics/models'
import * as ShortAPI from '../../api/short/index'
import * as ShortModels from '../../api/short/models'
import { AccessTime } from '@material-ui/icons'
import moment from "moment"
import "moment/locale/da"
import daLocale from "date-fns/locale/da"
import NoDataDialog from '../../components/dialogs/ErrorDialog'
import APIRequest from '../../components/helpers/APIRequest'
import * as CSV from '../../utils/exportcsv'
import LoadingSymbols from '../../utils/loadingSymbol'
import * as mobilbase from '../../api/mobilbase';

moment.locale("da")

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            padding: '0',
        },
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    buts: {
        width: '100%',
        height: '100%',
        padding: '0',
        marginTop: '0.5rem'
    },
    autoFrom: {
        width: '100%',
        height: '100%',
        marginTop: '0.5rem'
    },
    autoForm:{
        maxHeight: "60px",
        overflow: "auto"
    },
    grid: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    textHelp: {
        marginTop: '1rem'
    },
    margTop: {
        marginTop: theme.spacing(2),
    }
}))

const AlarmsStatistics: FC = () => {
    const classes = useStyles()

    const [currentLocation, setCurrentLocation] = useState(-1)
    const [locations, setLocations] = useState<ShortModels.Location[]>([])
    const [isPendingLocations, setIsPendingLocations] = useState(false)
    const [runLocations, setRunLocations] = useState(true)

    const [devices, setDevices] = useState<StatsModels.DeviceListResponse>(new StatsModels.DeviceListResponse())
    const [isPendingDevices, setIsPendingDevices] = useState(false)
    const [runGetDevices, setRunGetDevices] = useState(false)

    const [alarmsData, setAlarmsData] = useState<StatsModels.AlarmsResponse>(new StatsModels.AlarmsResponse())
    const [isPending, setIsPending] = useState(false)
    const [run, setRun] = useState(false)
    const [showError, setShowError] = useState(false)
    const [fromDate, setFromDate] = useState<Date | null>(new Date())
    const [toDate, setToDate] = useState<Date | null>(new Date())
    const [fromTime, setFromTime] = useState<Date | null>(new Date(0, 0, 0, 0, 0, 0, 0))
    const [toTime, setToTime] = useState<Date | null>(new Date(0, 0, 0, 23, 59, 0, 0))
    const [timeRange, setTimeRange] = useState(false)
    const [fetchData, setFetchData] = useState(false)
    const [downloadData, setDownloadData] = useState(false)

    const [pendingLoadingPicture, setPendingLoadingPicture] = useState(false)
    const [selectedDevices, setSelectedDevices] = useState<StatsModels.DeviceData[]>([])

    const [currentType, setCurrentType] = useState<number>(0)

    // Necessary for avoiding strikethrough on the comboboxes
    const labelLocationRef = useRef(null)
    const labelTypeRef = useRef(null)
    // @ts-ignore: Object is possibly 'null'
    const labelLocationWidth = (labelLocationRef !== null && labelLocationRef.current !== null) ? labelLocationRef.current.clientWidth : 0
    // @ts-ignore: Object is possibly 'null'
    const labelTypeWidth = (labelTypeRef !== null && labelTypeRef.current !== null) ? labelTypeRef.current.clientWidth : 0

    var keyList = [""]

    useEffect(() => {
        function handleKeyDown(event: any){
            const keyname = event.key
            keyList.push(keyname)
    
            if (event.shiftKey && keyList.includes("S") && keyList.includes("E")) {
                setDownloadData(true)
            }
            if (event.shiftKey && keyList.includes("S") && keyList.includes("H") ) {
                setFetchData(true)
            }
        }
        document.addEventListener("keydown", handleKeyDown)

        return function cleanUP() {
            document.removeEventListener("keydown", handleKeyDown)
        }
    })
    
    useEffect(() => {
        function handleKeyUp(event: any){
            keyList = [""]
            setDownloadData(false)
            setFetchData(false)
        }
        document.addEventListener("keyup", handleKeyUp)

        return function cleanUP() {
            document.removeEventListener("keyup", handleKeyUp)
        }
    })

    useEffect( () => {
        if (downloadData){
            downloadCSV()
        }
    }, [downloadData])

    useEffect( () => {
        if (fetchData){
            return setRun(true)
        }
    }, [fetchData])

    useEffect(() => {
        if (locations.length > 0 && currentLocation === -1) {
            setCurrentLocation(locations[0].id)
        }
    }, [locations, currentLocation])

    useEffect(() => {
        if (currentLocation > 0) {
            setRunGetDevices(true)
        }
    }, [currentLocation])

    useEffect(() => {  // show data fetching loading picture
        if (!isPending){
            setPendingLoadingPicture(false)
        }
        else{
            setPendingLoadingPicture(true)
        }
    }, [isPending])

    const renderType = (type: number) => {
        switch (type) {
            case 0: return "Alarm"       // Alarm
            case 1: return "Advarsel"    // Warning
            case 2: return "Indcheck"    // CheckIn
            case 3: return "Mønt"        // Coin
            case 4: return "Gratis"      // Free
            case 5: return "Udcheckning" // CardPost
            case 6: return "Betaling"    // CardPre
            case 7: return "MobilePay"   // MobilePay
        }
        return "?"
    }

    const renderStatus = (status: number) => {
        if (status === -1) {
            return "Deaktiveret"
        } else if (status === 0) {
            return "-"
        }
        return "Aktiveret"
    }

    const columns: Column<StatsModels.AlarmsData>[] = React.useMemo(() => [
        {Header: "Automat", id: "0", accessor: "deviceName"}, 
        {Header: "Tid", id: "1", accessor: "timeString", sortType: compareDateString}, 
        {Header: "Enhed / billetnr", id: "2", accessor: "unitOrTicket"}, 
        {Header: "Tekst", id: "3", accessor: "text"},
        {Header: "Type", id: "4", accessor: a => renderType(a.type)}, 
        {Header: "Status", id: "5", accessor: a => renderStatus(a.status)}
    ], [])

    const RequestData = () => {
        const fixDate = (date: Date | null, time: Date | null , startOfDay: boolean) => {
            // We have to send the date with a UTC timezone, or the server will get the value wrong
            var d1 = date ? date : new Date()
            var t1 = time ? time : new Date()
            var d = new Date(Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), t1.getHours(), t1.getMinutes(), 0, 0))
            
            return d
        }

        const param = (): StatsModels.AlarmsParams => {
            // Choose all devices if none are chosen
            var meters = selectedDevices.length < 1 ? devices.result : selectedDevices;
            return {location: currentLocation, body: {Start: fixDate(fromDate, fromTime, true), End: fixDate(toDate, toTime, false), Devices: meters.map((d) => d.id), ShowAllEvents: currentType === 0}}
        }

        return (<APIRequest<StatsModels.AlarmsResponse>
            run={run} setRun={setRun}
            pending={isPending} setIsPending={setIsPending}
            req={() => StatsAPI.getAlarmsReport(param())}
            setData={setAlarmsData}
            setShowError={setShowError}
        />)
    }

    const RequestLocationsData = () => {
        return (<APIRequest<ShortModels.Location[]>
            run={runLocations} setRun={setRunLocations}
            pending={isPendingLocations} setIsPending={setIsPendingLocations}
            req={ShortAPI.getLocations}
            setData={setLocations}
        />)
    }

    const RequestDevices = () => {
        return (<APIRequest<StatsModels.DeviceListResponse>
            run={runGetDevices} setRun={setRunGetDevices}
            pending={isPendingDevices} setIsPending={setIsPendingDevices}
            req={() => StatsAPI.getDeviceList(currentLocation)}
            setData={setDevices}
        />)
    }

    const setDevicesSelection = (newSelection: ShortModels.Device[] | null) => {
        if (newSelection) {
            setSelectedDevices(newSelection)
        } else {
            setSelectedDevices([])
        }
    }

    const handleTypeChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        const type = event.target.value as number
        if (type !== currentType) {
            setCurrentType(type)
            setAlarmsData(new StatsModels.AlarmsResponse())
        }
    }

    function compareDateString(rowA: any, rowB: any) {
        let a = rowA.original.time 
        let b = rowB.original.time

        if (a > b) return 1; 
        if (a < b) return -1;
        return 0;
    }
    
    const XlsxParam =():StatsModels.ParamsXlsx =>{
        var meters = selectedDevices.length < 1 ? devices.result : selectedDevices;
        let mett: number[] = meters.map((d) => d.id)
        const fixDate = (date: Date | null, time: Date | null , startOfDay: boolean) => {
            // We have to send the date with a UTC timezone, or the server will get the value wrong
            var d1 = date ? date : new Date()
            var t1 = time ? time : new Date()
            var d = new Date(Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), t1.getHours(), t1.getMinutes(), 0, 0))
            
            return d
        }
        return {
            location:currentLocation,
            body:{
                Start: fixDate(fromDate, fromTime, true), 
                End: fixDate(toDate, toTime, false),
                Meters: mett,
                ShowAllEvents: currentType === 0,
                Columns1:columns,
            }
        }

    }

    const downloadCSV = async () => {
        //CSV.exportAlarmsCSV("events.csv", columns.map(column => {return "" + column.Header}), alarmsData.result, renderType, renderStatus)
        setPendingLoadingPicture(true) // start loading symbol
        await mobilbase.requestXlsx("events.xlsx",'events',XlsxParam())
        .then((res) => {
            setPendingLoadingPicture(false) // ends loading symbol
        })
        .catch((err) =>{
            setPendingLoadingPicture(false) // end loading symbol
            setShowError(true) // if something fails, start error message
        })    
    }

    function updateLocValue(val: any){ // the method that the currentlocation gets updated from the Autocomplete
        let updatedLocValue = val?.id
        setSelectedDevices([]) // clears the selected devices

        if (updatedLocValue === null){
            return false
        }
        else{
        setCurrentLocation(updatedLocValue)
        return true
        }
    }

    return (
        <Container maxWidth={false}>
            <LoadingSymbols pendingLoadingPicture={pendingLoadingPicture} setPendingLoadingPicture={pendingLoadingPicture} open={pendingLoadingPicture} loadingSymbolText={"Henter data, vent venligst..."} />
            <RequestData />
            <RequestLocationsData />
            <RequestDevices />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">Alarmstatistik</Typography>

                <Container maxWidth={"lg"} className={classes.margTop}>
                    <MuiPickersUtilsProvider locale={daLocale} utils={DateFnsUtils}>
                        <Grid container spacing={2} alignItems="center" justify="center">
                            <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth margin="normal">
                                    <InputLabel ref={labelLocationRef} shrink htmlFor="alarms-location"></InputLabel>
                                    <Autocomplete id="id" options={locations} getOptionLabel={option => option.name} onChange={(event, value) => updateLocValue(value)} renderInput={params => ( <TextField {...params} label="Pladser" variant="outlined" />  )}/>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete className={classes.autoFrom} multiple value={selectedDevices} options={devices.result} getOptionLabel={option => option.name}
                                    renderInput={params => (<TextField {...params} label={selectedDevices.length === 0 ? "Automater - alle valgt" : "Automater"} variant="outlined" fullWidth />)}
                                    onChange={(event: any, newSelection: ShortModels.Device[] | null) => setDevicesSelection(newSelection)} />
                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardDatePicker fullWidth disableToolbar variant="inline" inputVariant="outlined" format="dd-MM-yyyy" margin="normal" id="date-picker-inline" label="Fra dato" value={fromDate} onChange={setFromDate} KeyboardButtonProps={{'aria-label': 'Set dato'}} />
                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardDatePicker fullWidth disableToolbar variant="inline" inputVariant="outlined" format="dd-MM-yyyy" margin="normal" id="date-picker-inline" label="Til dato" value={toDate} onChange={setToDate} KeyboardButtonProps={{'aria-label': 'Set dato'}} />
                            </Grid>
                            <Grid item xs={6}>
                             <KeyboardTimePicker onClick={() =>{setTimeRange(true)}} fullWidth disableToolbar variant="inline" ampm={false} keyboardIcon={<AccessTime />} inputVariant="outlined" format="HH:mm"  margin="normal" id="time-picker-inline" label="Fra tid" value={fromTime} onChange={setFromTime} KeyboardButtonProps={{'aria-label': 'Set time'}} />
                            </Grid>
                            <Grid item xs={6}>
                             <KeyboardTimePicker onClick={() =>{setTimeRange(true)}} fullWidth disableToolbar variant="inline" ampm={false} keyboardIcon={<AccessTime />} inputVariant="outlined" format="HH:mm" margin="normal" id="time-picker-inline" label="Til tid" value={toTime} onChange={setToTime} KeyboardButtonProps={{'aria-label': 'Set time'}} />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth margin="normal">
                                    <InputLabel ref={labelTypeRef} shrink htmlFor="current-stat-input">Type</InputLabel>
                                    <Select labelWidth={labelTypeWidth} value={currentType} onChange={handleTypeChange} inputProps={{name: 'currentStat', id: 'current-stat-input' }}>
                                        <MenuItem key={0} value={0}>Alle hændelser</MenuItem>
                                        <MenuItem key={0} value={1}>Kun alarmer</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} alignItems="center" justify="center">
                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" className={classes.buts} onClick={() => setRun(true)}>Hent statistik</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button disabled={alarmsData.result.length < 1} variant="contained" color="primary" className={classes.buts} onClick={downloadCSV}>Eksportér</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MuiPickersUtilsProvider>
                    {/* </Paper> */}
                {/* </div> */}
                </Container>
                <div className={classes.grid}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Table<StatsModels.AlarmsData> columns={columns} data={alarmsData.result} initialState={{pageSize: 150}} clickEvent={() => {}} update={null} pending={false} text={""}/>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <NoDataDialog open={showError} onClose={() => { setShowError(false) }} title={"Intet svar"} text={"Noget gik galt, prøv venligst igen senere."}/>
        </Container>
    )
}

export default AlarmsStatistics
